export default __webpack_public_path__ + "static/media/space-palace.9ae4aace.png";